module.exports = __webpack_public_path__ + "static/media/LABDigital.3e50dc16.ttf";